var _rect, _circle, _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00267,
    y: 1.50267,
    width: 14.0374,
    height: 14.0374,
    rx: 3.81016,
    stroke: "white",
    strokeWidth: 2.00535
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0027,
    cy: 8.56141,
    r: 5.57487,
    fill: "#FF3636"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2_131",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5989 10.9L18.6096 8.49999L14.5989 6.09999"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5963 10.9L13.5963 11.9027L15.6016 11.9027L15.6016 10.9L13.5963 10.9ZM15.6016 6.09999L15.6016 5.09732L13.5963 5.09732L13.5963 6.09999L15.6016 6.09999ZM13.5963 6.09999L13.5963 10.9L15.6016 10.9L15.6016 6.09999L13.5963 6.09999ZM13.5692 9.17921L11.8484 10.2089L13.9079 13.6505L15.6286 12.6208L13.5692 9.17921ZM18.6096 8.49999L19.6393 10.2208L22.515 8.49999L19.6393 6.77921L18.6096 8.49999ZM15.6286 4.37921L13.9079 3.34949L11.8484 6.79106L13.5692 7.82078L15.6286 4.37921ZM15.6286 12.6208L19.6393 10.2208L17.5799 6.77921L13.5692 9.17921L15.6286 12.6208ZM19.6393 6.77921L15.6286 4.37921L13.5692 7.82078L17.5799 10.2208L19.6393 6.77921Z",
    fill: "white",
    mask: "url(#path-3-inside-1_2_131)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00135 6.51999L6.01605 8.49999L8.00135 10.48",
    stroke: "white",
    strokeWidth: 2.00535,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.bced1bf63cd7b2b307edcc0df7894873.svg";
export { ForwardRef as ReactComponent };